module.exports = __webpack_public_path__ + "img/news_02.ccc13fce.jpg";